const setLocalStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error al guardar '${key}' en localStorage:`, error);
  }
};

export default setLocalStorageItem